import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import '../scss/index.scss';

const root = document.querySelector('#app');

ReactDOM.render(<App />, root);
